module.exports = __webpack_public_path__ + "media/icons/opony-zimowe-green-ce906261.png";